import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form1" }
const _hoisted_2 = { class: "story" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "panel_left" }
const _hoisted_5 = { class: "image-slot" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "image-slot" }
const _hoisted_8 = { class: "image-slot" }
const _hoisted_9 = { class: "panel_right" }
const _hoisted_10 = {
  key: 0,
  class: "title"
}
const _hoisted_11 = {
  key: 1,
  class: "example1"
}
const _hoisted_12 = { style: {"white-space":"pre-wrap"} }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            style: {"max-width":"600px"},
            "label-position": "top",
            rules: _ctx.rules,
            ref: "ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "关卡标题",
                prop: "levelTitle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.levelTitle,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.levelTitle) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "难易度",
                prop: "difficulty"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_rate, {
                    modelValue: _ctx.form.difficulty,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "角色提示",
                prop: "selectRole"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.selectRole2,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectRole2) = $event)),
                    placeholder: "Select",
                    multiple: "",
                    onChange: _ctx.valueChange,
                    size: "large",
                    style: {"width":"240px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]),
                  _createVNode(_component_el_alert, {
                    title: "可以使用 。 符号 作为角色信息的分隔标识",
                    type: "success",
                    closable: false,
                    style: {"margin":"10px 0"}
                  }),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.roleTip,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.roleTip) = $event)),
                    type: "textarea",
                    size: "large",
                    rows: "10",
                    placeholder: "角色1提示。\r\n角色2提示。",
                    maxlength: "500",
                    "show-word-limit": "",
                    style: {"margin-top":"10px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "题目类型",
                prop: "region"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.region,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.region) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "填空题",
                        value: "填空题"
                      }),
                      _createVNode(_component_el_option, {
                        label: "选择题",
                        value: "选择题"
                      }),
                      _createVNode(_component_el_option, {
                        label: "AR题",
                        value: "AR题"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_ctx.form.region == '填空题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "关卡谜题内容",
                    prop: "levelContent",
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.levelContent,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.levelContent) = $event)),
                        type: "textarea",
                        size: "large",
                        rows: "10",
                        maxlength: "800",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.form.region == '填空题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    prop: "levelCover",
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        class: "avatar-uploader",
                        action: _ctx.UpdateApi,
                        "show-file-list": false,
                        "on-success": _ctx.handleAvatarSuccess,
                        "before-upload": _ctx.beforeAvatarUpload,
                        limit: 1,
                        "file-list": _ctx.fileList,
                        disabled: _ctx.allowUpload
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.levelCover)
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: _ctx.form.levelCover,
                                class: "avatar",
                                alt: "",
                                fit: 'contain'
                              }, {
                                error: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icon_picture)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["src"]))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "avatar-uploader-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Plus)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.allowUpload && _ctx.form.region == '填空题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: _ctx.clearImage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.form.region == '填空题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    label: "关卡答案",
                    prop: "levelDesc",
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.levelDesc,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.levelDesc) = $event)),
                        type: "textarea",
                        size: "large",
                        rows: "5",
                        maxlength: "400",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.form.region == '选择题')
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 4,
                    title: "提醒",
                    type: "warning",
                    description: "请至少包含两个选项否则不会被录入",
                    closable: false
                  }))
                : _createCommentVNode("", true),
              _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
              (_ctx.form.region == '选择题')
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.domains, (domain, index) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: domain.key,
                      class: "animate__animated animate__fadeInRight",
                      label: '题目' + (index + 1),
                      prop: 'domains.' + index + '.value'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: domain.value,
                          "onUpdate:modelValue": ($event: any) => ((domain.value) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_el_radio_group, {
                          modelValue: domain.rightAnswer,
                          "onUpdate:modelValue": ($event: any) => ((domain.rightAnswer) = $event),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domain.options, (item2, index2) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "option",
                                key: index2
                              }, [
                                _createVNode(_component_el_input, {
                                  modelValue: item2.one,
                                  "onUpdate:modelValue": ($event: any) => ((item2.one) = $event),
                                  style: {"width":"50%"}
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_el_radio, {
                                  value: item2.one,
                                  size: "large",
                                  style: {"width":"3%","margin-left":"20px"}
                                }, null, 8, ["value"]),
                                _createElementVNode("p", {
                                  class: "text",
                                  onClick: ($event: any) => (_ctx.deleteOption(domain, index2))
                                }, "删除", 8, _hoisted_6)
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_el_button, {
                          class: "mt-2",
                          onClick: _withModifiers(($event: any) => (_ctx.removeDomain(domain)), ["prevent"])
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" 删除 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          class: "mt-2",
                          onClick: _withModifiers(($event: any) => (_ctx.addOption(domain)), ["prevent"])
                        }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode(" 添加选项 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["label", "prop"]))
                  }), 128))
                : _createCommentVNode("", true),
              (_ctx.form.region == '选择题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 6,
                    class: "animate__animated animate__fadeInRight"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { onClick: _ctx.addDomain }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("添加题目", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, { onClick: _ctx.resetForm }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("重置", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.form.region == 'AR题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 7,
                    label: "关卡谜题内容",
                    prop: "arQuestion",
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.arQuestion,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.arQuestion) = $event)),
                        type: "textarea",
                        size: "large",
                        rows: "10",
                        maxlength: "500",
                        "show-word-limit": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.form.region == 'AR题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 8,
                    prop: "arImageRecognition",
                    class: "animate__animated animate__fadeInLeft",
                    label: "识别图"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        class: "avatar-uploader",
                        action: _ctx.UpdateApi,
                        "show-file-list": false,
                        "on-success": _ctx.handleAvatarSuccess2,
                        "before-upload": _ctx.beforeAvatarUpload,
                        limit: 1,
                        "file-list": _ctx.fileList2,
                        disabled: _ctx.allowUpload2
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.arImageRecognition)
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: _ctx.form.arImageRecognition,
                                class: "avatar",
                                alt: "",
                                fit: 'contain'
                              }, {
                                error: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icon_picture)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["src"]))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "avatar-uploader-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Plus)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.allowUpload2 && _ctx.form.region == 'AR题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 9,
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: _ctx.clearImage2
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.form.region == 'AR题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 10,
                    prop: "arImageRecognition",
                    class: "animate__animated animate__fadeInLeft",
                    label: "内容图"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        class: "avatar-uploader",
                        action: _ctx.UpdateApi,
                        "show-file-list": false,
                        "on-success": _ctx.handleAvatarSuccess3,
                        "before-upload": _ctx.beforeAvatarUpload,
                        limit: 1,
                        "file-list": _ctx.fileList3,
                        disabled: _ctx.allowUpload3
                      }, {
                        default: _withCtx(() => [
                          (_ctx.form.arImageContent)
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: _ctx.form.arImageContent,
                                class: "avatar",
                                alt: "",
                                fit: 'contain'
                              }, {
                                error: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_icon_picture)
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }, 8, ["src"]))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "avatar-uploader-icon"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Plus)
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.allowUpload3 && _ctx.form.region == 'AR题')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 11,
                    class: "animate__animated animate__fadeInLeft"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: _ctx.clearImage3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.form.region !== 'AR题')
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "App示意图"))
            : _createCommentVNode("", true),
          (_ctx.form.region == '填空题')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_el_icon, { size: "20" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowLeft)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("span", null, [
                    _createVNode(_component_el_icon, { size: "20" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.form.levelTitle), 1),
                _createElementVNode("p", null, [
                  _createElementVNode("span", null, [
                    _cache[18] || (_cache[18] = _createTextVNode("难度", -1)),
                    _createVNode(_component_el_rate, {
                      modelValue: _ctx.form.difficulty,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                      size: "small"
                    }, null, 8, ["modelValue"])
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "故事回忆", -1))
                ]),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.form.levelContent), 1),
                _createElementVNode("p", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "此处的线索", -1)),
                  _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: _ctx.form.levelCover,
                      alt: ""
                    }, null, 8, _hoisted_13)
                  ])
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("p", null, [
                  _createElementVNode("span", null, "输入答案")
                ], -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.form.region == '选择题')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.domains, (item, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "example2",
                  key: index
                }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, [
                      _createVNode(_component_el_icon, {
                        size: "20",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePanel(0)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowLeft)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("span", null, [
                      _createVNode(_component_el_icon, {
                        size: "20",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePanel(1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowRight)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_ctx.form.levelTitle), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, [
                      _cache[22] || (_cache[22] = _createTextVNode("难度", -1)),
                      _createVNode(_component_el_rate, {
                        modelValue: _ctx.form.difficulty,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.difficulty) = $event)),
                        size: "small"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("p", null, _toDisplayString(item.value), 1),
                  _createElementVNode("p", null, [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.radio1,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.radio1) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (item2, index2) => {
                          return (_openBlock(), _createElementBlock("i", { key: index2 }, [
                            _createVNode(_component_el_radio, {
                              value: item2.one,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item2.one), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue"])
                  ]),
                  _cache[23] || (_cache[23] = _createElementVNode("p", null, [
                    _createElementVNode("span", null, "确定")
                  ], -1))
                ])), [
                  [_vShow, index == _ctx.selectNumber]
                ])
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}